import React from "react";
import SiteWrapper from "components/Layouts/SiteWrapper";
import { useNavigate } from "react-router-dom";
import SiteDetailsContent from "./SiteDetailsContent";
import { useParams } from "react-router-dom";
import { getLocalStorageData } from "helpers/utils";
import { getSiteNavigationFromStorage } from "helpers/siteNavigation";

const SiteDetail = () => {
	const navigate = useNavigate();
	const { id, clientId } = useParams();
	
	const navigation = getSiteNavigationFromStorage(getLocalStorageData);

    return (
        <SiteWrapper
            navigation={navigation}
            onNavClick={(urlToGo) =>
                navigate(`/app/clients/${clientId}/sites/${id}${urlToGo}`)
            }
            current="Details"
        >
            <SiteDetailsContent />
        </SiteWrapper>
    );
};

export default SiteDetail;
